// MainStatsComponent.js
import React, { useEffect, useState } from "react";
import axios from "axios";
import configApi from "../../config";
import TermStats from "./TermStats";
import PatientStats from "./PatientStats";
import OccupiedTermsChart from "./OccupiedTermsChart";
import TermTypePieChart from './TermTypePieChart';
import TermsOverTimeChart from './TermsOverTimeChart';
import TermsHeatmap from './TermsHeatmap';
import TopCustomers from './TopCustomers';
import TotalReservations from './TotalReservations';
import AllTimeRevenue from './AllTimeRevenue';
import UniquePatients from './UniquePatients';
import RevenuePieChart from './RevenuePieChart';
import LostRevenue from './LostRevenue';
import AverageBookingValue from './AverageBookingValue';
import BusiestDay from './BusiestDay';
import TrafficByDayChart from './TrafficByDayChart';
import TrafficByHourChart from './TrafficByHourChart';
import RevenueByDayChart from './RevenueByDayChart';
import RevenueByYearChart from './RevenueByYearChart';

const MainStatsComponent = () => {
  const [terms, setTerms] = useState([]);
  const [patients, setPatients] = useState([]);

  const token = localStorage.getItem("token");
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  useEffect(() => {
    fetchTerms();
    fetchPatients();
  }, []);

  const fetchTerms = async () => {
    try {
      const response = await axios.get(
        `${configApi.apiEndpoint}/api/Terms`,
        config
      );
      setTerms(response.data);
    } catch (error) {
      console.log(error);
    }
  };

  const fetchPatients = async () => {
    try {
      const response = await axios.get(
        `${configApi.apiEndpoint}/api/Patients`,
        config
      );
      setPatients(response.data);
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <div className="home-container mt-4">
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h2 className="m-0 fw-bold" style={{ color: 'var(--pantone)' }}>Hlavný Dashboard</h2>
      </div>

      <div className="row gx-4 gy-4">
        {/* KPI Row */}
        <div className="col-xl col-lg-3 col-md-4 col-sm-6 mb-4">
          <TotalReservations />
        </div>
        <div className="col-xl col-lg-3 col-md-4 col-sm-6 mb-4">
          <AllTimeRevenue />
        </div>
        <div className="col-xl col-lg-3 col-md-4 col-sm-6 mb-4">
          <AverageBookingValue />
        </div>
        <div className="col-xl col-lg-3 col-md-4 col-sm-6 mb-4">
          <LostRevenue />
        </div>
        <div className="col-xl col-lg-3 col-md-4 col-sm-6 mb-4">
          <PatientStats />
        </div>
        <div className="col-xl col-lg-3 col-md-4 col-sm-6 mb-4">
          <UniquePatients />
        </div>
        <div className="col-xl col-lg-3 col-md-4 col-sm-6 mb-4">
          <BusiestDay />
        </div>
      </div>

      <div className="row gx-4 gy-4">
        {/* Trend Charts */}
        <div className="col-lg-6 mb-4">
          <TermsOverTimeChart />
        </div>
        <div className="col-lg-6 mb-4">
          <OccupiedTermsChart />
        </div>
      </div>

      <div className="row gx-4 gy-4">
        {/* Breakdowns */}
        <div className="col-lg-6 mb-4">
          <RevenuePieChart />
        </div>
        <div className="col-lg-6 mb-4">
          <TopCustomers />
        </div>
      </div>

      <div className="row gx-4 gy-4">
        {/* Deep Analytics */}
        <div className="col-lg-6 mb-4">
          <TrafficByDayChart />
        </div>
        <div className="col-lg-6 mb-4">
          <TrafficByHourChart />
        </div>
      </div>

      <div className="row gx-4 gy-4">
        {/* Financial Breakdowns */}
        <div className="col-lg-6 mb-4">
          <RevenueByDayChart />
        </div>
        <div className="col-lg-6 mb-4">
          <RevenueByYearChart />
        </div>
      </div>

      <div className="row gx-4 gy-4 mt-2">
        {/* Heatmap Footer */}
        <div className="col-12 mb-4">
          <TermsHeatmap />
        </div>
      </div>
    </div>
  );
};

export default MainStatsComponent;
